<template>
  <v-dialog v-model="dialog" width="700" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Add Department</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                <v-subheader>Category</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="8" lg="8"> : {{ form.name }} </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                <v-subheader>Department</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="8" lg="8">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  :items="departments"
                  item-text="name"
                  return-object
                  v-model="department"
                  @change="onChangeDepartment"
                >
                  <template v-slot:item="data">
                    <v-list-item v-on="data.on">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-data-table
              :headers="headers"
              :items="form.departments"
              dense
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.no="{ index }">
                {{ index + 1 }}
              </template>
              <template v-slot:item.action="{ item, index }">
                <v-btn color="error" @click="deleteItem(item, index)" v-if="!item.deleted"
                  >Delete</v-btn
                >
                <v-btn color="success" @click="undoItem(index)" v-if="item.deleted">Undo</v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">
          Close
        </v-btn>
        <v-btn color="primary" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-form-department",
  props: {
    dialog: Boolean,
    form: Object,
    departments: Array,
  },
  data() {
    return {
      department: null,
      headers: [
        {
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Department Name",
          value: "departmentName",
          sortable: false,
          divider: true,
          align: "center",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
          divider: true,
          align: "center",
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    save() {
      this.$emit("save", this.form);
    },
    close() {
      this.$emit("close");
    },
    deleteItem(item, index) {
      if (item.id) {
        this.form.departments[index].deleted = true;
      } else {
        this.form.departments.splice(index, 1);
      }
    },
    undoItem(index) {
      this.form.departments[index].deleted = false;
    },
    onChangeDepartment(val) {
      if (val) {
        const isUsed = this.form.departments.some(department => department.departmentId === val.id);
        if (isUsed) {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Department already added",
          });
        } else {
          this.form.departments.push({
            departmentId: val.id,
            departmentName: val.name,
            deleted: false,
          });
        }
      }
    },
  },
};
</script>

<style></style>
